export const displayMap = () => {
    const htmlMap = document.getElementsByClassName('Map')[0];
    htmlMap.classList.remove('Map-hidden');
};

export const hideMap = () => {
    const htmlMap = document.getElementsByClassName('Map')[0];
    htmlMap.classList.add('Map-hidden');
};
